import PropTypes from 'prop-types';
import React from 'react';
import { AssistantMessage, TranscriptBubble, UserMessage } from './MessageBubble';

/**
 * Conversation view container displaying all messages
 */
const ConversationView = ({
  messages,
  transcript,
  isRecording,
  speechEnabled,
  conversationRef,
}) => {
  return (
    <div ref={conversationRef} className="flex-1 overflow-auto px-4 py-4 space-y-4">
      {messages.map((message, index) => {
        if (message.role === 'system') return null;

        if (message.role === 'user') {
          return <UserMessage key={message.id || index} content={message.content} />;
        } else if (message.role === 'assistant') {
          return (
            <AssistantMessage
              key={message.id || index}
              message={message}
              speechEnabled={speechEnabled}
            />
          );
        }

        return null;
      })}

      {isRecording && transcript && <TranscriptBubble transcript={transcript} />}
    </div>
  );
};

ConversationView.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      role: PropTypes.oneOf(['system', 'user', 'assistant']).isRequired,
      content: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  transcript: PropTypes.string,
  isRecording: PropTypes.bool.isRequired,
  speechEnabled: PropTypes.bool.isRequired,
  conversationRef: PropTypes.shape({ current: PropTypes.any }),
};

ConversationView.defaultProps = {
  transcript: '',
  conversationRef: null,
};

export default ConversationView;
